/* eslint-disable react/jsx-props-no-spreading */
import { useUrlGenerator } from '@micromag/core/contexts';
import Editor from '@micromag/editor';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useParams } from 'wouter';

import useAutoSave from '../../../hooks/useAutoSave';
import useTheme from '../../../hooks/useTheme';
import useThemeUpdate from '../../../hooks/useThemeUpdate';

// import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { useApp } from '../../../contexts/AppContext';
import { useOrganisation } from '../../../contexts/OrganisationContext';
import MainLayout from '../../layouts/Main';
import ThemeNavbar from '../../navbars/Theme';

const propTypes = {
    autoSaveDelay: PropTypes.number,
    className: PropTypes.string,
};

const defaultProps = {
    autoSaveDelay: 10,
    className: null,
};

const ThemeEditorPage = ({ autoSaveDelay, className }) => {
    const url = useUrlGenerator();
    const organisation = useOrganisation();
    const { branding = {}, namespaces = null } = organisation || {};
    const { memoryRouter } = useApp();
    const { theme: themeId } = useParams();

    const { theme } = useTheme(themeId);

    const { update: updateTheme, updating } = useThemeUpdate(themeId);

    const saveTheme = useCallback(
        (newTheme = null) => {
            if (newTheme !== null) {
                updateTheme(newTheme);
            }
        },
        [updateTheme],
    );

    const {
        storyValue: editorTheme,
        valueChanged,
        onChange,
        onManualSave,
        onUndo,
        canUndo,
    } = useAutoSave(theme, {
        delay: autoSaveDelay,
        onSave: saveTheme,
        disabled: false,
    });

    return (
        <MainLayout
            fullscreen
            navbar={
                editorTheme !== null ? (
                    <ThemeNavbar
                        theme={editorTheme}
                        onClickSave={onManualSave}
                        onUndo={onUndo}
                        canUndo={canUndo}
                        saving={updating}
                        canSave={valueChanged}
                    />
                ) : null
            }
        >
            <div className={className}>
                {editorTheme !== null ? (
                    <Editor
                        value={editorTheme}
                        basePath={url('themes.editor', {
                            theme: theme !== null ? theme.id : themeId,
                        })}
                        isTheme
                        viewerTheme={branding}
                        memoryRouter={memoryRouter}
                        fullscreen
                        onChange={onChange}
                        screenNamespaces={namespaces}
                    />
                ) : null}
            </div>
        </MainLayout>
    );
};

ThemeEditorPage.propTypes = propTypes;
ThemeEditorPage.defaultProps = defaultProps;

export default ThemeEditorPage;
